import { Injectable } from '@angular/core';
import { Order, OrderApi, OrderStep } from '../interfaces/order.interface';
import { PipeTransform } from '@angular/core';
import { filter, Observable } from 'rxjs';
import { OrderStatusKeysEnum } from '../enums/order-status-keys.enum';
import { apiConfiguration } from '../app.config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FRONT_RESPONSE } from '../interfaces/front-settings.interface';
import { environment } from '../../environments/environment';
import { UrlImageDefaultEnum } from '../enums/image.enum';


@Injectable({
  providedIn: 'root'
})
export class ApiHomologationService {


  //define maps
  static defaultSteps: OrderStep[] = [
    {
      id: "OrderPlaced",
      label: "Pedido recibido",
      description: "Hemos recibido tu pedido y te avisaremos cuando el pago esté aprobado.",
      icon: "assets/images/icon-order-placed.svg",
      finalStep: false,
      homologation: ["Creado", "Confirmado", "Recibido", "Pedido Recibido"],
      enabled: true,
      order: 1,
      shippingCondition: ["*"]
    },
    {
      id: "PaymentApproved",
      label: "Pago aprobado",
      description: "Hemos recibido tu pago y comenzaremos a trabajar en tu pedido.",
      icon: "assets/images/icon-order-approved-paiment.svg",
      finalStep: false,
      homologation: ["Pedido Facturado", "Facturado"],
      enabled: true,
      order: 2,
      shippingCondition: ["*"]
    },
    {
      id: "OrderInPrepartion",
      label: "Pedido confirmado",
      description: "Estamos preparando tu pedido y te avisaremos cuando esté listo para ser enviado.",
      icon: "assets/images/icon-order-in-preparation.svg",
      finalStep: false,
      homologation: ["Pedido Confirmado", "En preparación"],
      enabled: true,
      order: 3,
      shippingCondition: ["*"]
    },
    {
      id: "OrderInTransit",
      label: "Pedido en ruta para entrega",
      description: "Tu pedido está en ruta de entrega ¡Prepárate para recibirlo hoy!",
      icon: "assets/images/icon-order-in-route.svg",
      finalStep: false,
      homologation: ["Tu pedido está en camino", "En Ruta", "En camino", "En tránsito"],
      enabled: true,
      order: 4,
      shippingCondition: ["*"]
    },
    {
      id: "OrderDelivered",
      label: "Pedido entregado",
      description: "Tu pedido ha sido entregado ¡disfruta tu producto!",
      icon: "assets/images/icon-order-delivered.svg",
      finalStep: true,
      homologation: ["Pedido entregado", "Entregado"],
      enabled: true,
      order: 5,
      shippingCondition: ["*"]
    },
    {
      id: "OrderCancelled",
      label: "Pedido cancelado",
      description: "Tu pedido ha sido cancelado.",
      icon: "assets/images/icon-order-cancelled.svg",
      finalStep: true,
      homologation: ["Pedido Cancelado", "Cancelado"],
      enabled: true,
      order: 6,
      shippingCondition: ["*"]
    },
    {
      id: "OrderReturned",
      label: "Pedido Devuelto",
      description: "Tu pedido no pudo ser entregado por lo que será devuelto a Mabe",
      icon: "assets/images/icon-order-returned.svg",
      finalStep: true,
      homologation: ["Pedido Devuelto", "Devolución", "devolucion inmediata"],
      enabled: true,
      order: 7,
      shippingCondition: ["*"]
    }
  ];

  static steps: OrderStep[] = [...ApiHomologationService.defaultSteps];

  static skuExcepted: string[] = [
    '801',
    'HD_',
  ];

  static installationServiceSku: string[] = ['HD_INST_AA', 'HD_INST_CALE', 'HD_INST_CAMI', 'HD_INST_CAMP', 'HD_INST_HE', 'HD_INST_MOCA', 'HD_INST_TRAD'];
  static maneuveringServicesSku: string[] = ['HD_MANIOBRA', 'HD_RECOLECCION'];
  static warrantyExtensionServiceSku: string[] = ['801'];

  tradingPartners: any[] = [];

  constructor(
    private http: HttpClient
  ) {
    const timestamp = new Date().getTime();
    let url = `${environment.url}/v1/parameterized-states?nocache=${timestamp}`;
    //url = "assets/mocks/parametrized-states-mock.json"
    this.http.get<FRONT_RESPONSE>(url).subscribe({
      next: (data) => {
        if (data.content && Array.isArray(data.content) && data.content.length > 0) {
          ApiHomologationService.steps = data.content as unknown as OrderStep[];
        }
      },
      error: (error) => {
        console.log(error);
      }
    });


    this.http.get<any>(`${environment.url}/v1/cat-trading-partner`).subscribe({
      next: (data) => {
        if (data.content) {
          this.tradingPartners = data.content;
        }
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  static normalizeText(text?: string | null): string {
    if (!text) return '';
    return text
      .toString()
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  static isTrackingMatch(itemTracking?: string | null, targetTracking?: string | null): boolean {
    if (!targetTracking || targetTracking.trim() === '' || targetTracking.trim().toUpperCase() === 'NN') {
      return true;
    }
    if (!itemTracking || itemTracking.trim() === '') {
      return true;
    }
    return itemTracking.trim().toLowerCase() === targetTracking.trim().toLowerCase();
  }

  static getExpandedEquivalents(step: OrderStep): string[] {
    const set = new Set<string>();
    (step.homologation || []).forEach(h => {
      const norm = ApiHomologationService.normalizeText(h);
      if (norm) set.add(norm);
    });

    const normLabel = ApiHomologationService.normalizeText(step.label);
    if (normLabel) set.add(normLabel);

    const id = (step.id || '').toLowerCase();
    if (id.includes('transit') || normLabel.includes('ruta') || normLabel.includes('camino')) {
      [
        'tu pedido esta en camino',
        'en ruta',
        'en camino',
        'en transito',
        'en ruta de entrega',
        'en reparto',
        'recolectado',
        'embarcado',
        'despachado',
        'salida a ruta',
        'en ruta a sucursal',
        'en transito a destino',
        'en transito a sucursal de transporte'
      ].forEach(s => set.add(s));
    } else if (id.includes('placed') || normLabel.includes('recibido') || normLabel.includes('realizado')) {
      ['creado', 'confirmado', 'recibido', 'pedido recibido', 'pedido realizado', 'generado', 'orden creada', 'registrado'].forEach(s => set.add(s));
    } else if (id.includes('payment') || normLabel.includes('pago') || normLabel.includes('factura')) {
      ['pedido facturado', 'facturado', 'pago aprobado', 'pago confirmado', 'aprobado'].forEach(s => set.add(s));
    } else if (id.includes('prepartion') || id.includes('preparation') || normLabel.includes('confirmado') || normLabel.includes('preparac')) {
      ['pedido confirmado', 'en preparacion', 'preparando pedido', 'en surtido', 'surtido', 'asignado'].forEach(s => set.add(s));
    } else if (id.includes('delivered') || normLabel.includes('entregado')) {
      ['pedido entregado', 'entregado', 'entregada', 'entrega exitosa', 'finalizado'].forEach(s => set.add(s));
    } else if (id.includes('cancel') || normLabel.includes('cancel')) {
      ['pedido cancelado', 'cancelado', 'cancelada', 'anulado'].forEach(s => set.add(s));
    } else if (id.includes('return') || normLabel.includes('devuelt')) {
      ['pedido devuelto', 'devolucion', 'devolucion inmediata', 'retornado', 'devuelto'].forEach(s => set.add(s));
    } else if (id.includes('harvest') || normLabel.includes('recoleccion en mabe')) {
      ['pedido listo para recoleccion en mabe', 'recoleccion en mabe'].forEach(s => set.add(s));
    } else if (id.includes('readyintransportation') || normLabel.includes('recoleccion en sucursal')) {
      ['pedido listo para recoleccion en sucursal de transporte', 'recoleccion en sucursal'].forEach(s => set.add(s));
    }

    return Array.from(set);
  }

  static statusMatchesEquivalents(status: string | null | undefined, equivalents: string[]): boolean {
    if (!status) return false;
    const norm = ApiHomologationService.normalizeText(status);
    if (!norm) return false;
    return equivalents.some(eq =>
      norm === eq ||
      (eq.length > 4 && norm.includes(eq)) ||
      (norm.length > 4 && eq.includes(norm))
    );
  }

  static mapToOrder(itemApi: OrderApi, trackingNumber?: string): Order {

    let steps: OrderStep[] = [];

    steps = this.homologateStatus(
      itemApi.historyStatus, 
      trackingNumber, 
      itemApi.shippingCondition, 
      itemApi.salesDocumentType,
      itemApi.orderStatusWebItem
    ).sort((a, b) => a.order - b.order);

    // Validate last completed step from history
    let lastCompletedIndex = -1;

    for (let i = 0; i < steps.length; i++) {
      if (steps[i].completed) {
        lastCompletedIndex = i;
      }
    }

    // Fallback: If orderStatusWebItem is available, reconcile with steps
    if (itemApi.orderStatusWebItem) {
      for (let i = steps.length - 1; i >= 0; i--) {
        const equivalents = ApiHomologationService.getExpandedEquivalents(steps[i]);
        if (ApiHomologationService.statusMatchesEquivalents(itemApi.orderStatusWebItem, equivalents)) {
          if (i > lastCompletedIndex) {
            lastCompletedIndex = i;
          }
          break;
        }
      }
    }

    // Minimum baseline: If order exists and has steps, at least step 0 (Pedido recibido) is active
    if (lastCompletedIndex < 0 && steps.length > 0) {
      lastCompletedIndex = 0;
    }

    for (let i = 0; i <= lastCompletedIndex; i++) {
      steps[i].completed = true;
    }

    const services: Order[] = [];
    itemApi.services?.forEach(orderApi => services.push(this.mapToOrder(orderApi)));

    let skuDesc = itemApi.descSKU;
    if (itemApi.imageSku == undefined) {
      if (itemApi.descSKU != null) {
        skuDesc = ApiHomologationService.capitalizeFirstLetter(itemApi.descSKU)! + " - " + itemApi.sku;
      } else {
        skuDesc = itemApi.sku;
      }
    }

    return {
      id: this.generateUniqueId(),
      name: skuDesc,
      sku: itemApi.sku,
      descSKU: skuDesc,
      image: itemApi.imageSku ?? UrlImageDefaultEnum.url,
      estimatedDelivery: itemApi.tentativeDeliveryDate!,
      descShippingCondition: itemApi.descShippingCondition,
      shippingCondition: itemApi.shippingCondition,
      tradingPartnerName: itemApi.tradingPartnerName,
      trackingNumber: steps.filter(x => x.trackingNumber).pop()?.trackingNumber || "",
      maneuver: itemApi.maneuver,

      steps: steps,
      completedSteps: lastCompletedIndex + 1,
      totalSteps: steps.length,
      services: services,

      //More details
      addressPostCode: itemApi.addressPostCode,
      addressCity1: itemApi.addressCity1,
      addressCity2: itemApi.addressCity2,
      addressStreet1: itemApi.addressStreet1,
      clientName: itemApi.clientName,
      phoneNumber: itemApi.phoneNumber,
      internalOrderNumber: itemApi.internalOrderNumber,
      email: itemApi.email,
      documentDate: this.formatDate(itemApi.documentDate),
      orderStatusWebItem: itemApi.orderStatusWebItem,
      salesDocument: itemApi.salesDocument,
      tradingPartnerId: itemApi.tradingPartnerId,
      salesDocumentType: itemApi.salesDocumentType,
      orderProfile: itemApi.orderProfile ?? 'ORDEN_ESTANDAR'
    };
  }

  static homologateStatus(
    historyStatus?: any[], 
    trackingNumber?: string, 
    shippingCondition?: string, 
    salesDocumentType?: string,
    orderStatusWebItem?: string
  ): OrderStep[] {

    const sourceSteps = (this.steps && this.steps.length > 0) ? this.steps : this.defaultSteps;

    const currentDocType = salesDocumentType ? salesDocumentType.trim().toUpperCase() : "";

    const isDocTypeMatch = (step: OrderStep): boolean => {
      if (!step.salesDocumentType || step.salesDocumentType.length === 0 || step.salesDocumentType.includes("*")) {
        return true;
      }
      return currentDocType !== "" && step.salesDocumentType.some(d => d.trim().toUpperCase() === currentDocType);
    };

    //check shippingCondition and salesDocumentType
    const stepsShipping = sourceSteps.filter(x => 
      x.enabled && 
      x.shippingCondition?.includes(shippingCondition!) && 
      isDocTypeMatch(x)
    );
    let filterShippingCondition = "*";
    if (stepsShipping.length > 0) {
      filterShippingCondition = shippingCondition!;
    }

    const updatedSteps: OrderStep[] = JSON.parse(
      JSON.stringify(
        sourceSteps.filter(x => 
          x.enabled && 
          x.shippingCondition?.includes(filterShippingCondition) && 
          isDocTypeMatch(x)
        )
      )
    );

    const steps = updatedSteps.map((step: OrderStep) => {
      const equivalents = ApiHomologationService.getExpandedEquivalents(step);
      if (equivalents.length > 0) {
        if (historyStatus && Array.isArray(historyStatus)) {

          const filteredStatus = historyStatus.filter(item => {
            if (!item || !item.status) return false;
            const matchesStatus = ApiHomologationService.statusMatchesEquivalents(item.status, equivalents);
            const matchesTracking = ApiHomologationService.isTrackingMatch(item.trackingNumber, trackingNumber);
            return matchesStatus && matchesTracking;
          });

          if (filteredStatus.length > 0) {
            const sortedStatus = filteredStatus.sort((a, b) => {
              if (a.trackingNumber && !b.trackingNumber) {
                return -1;
              }
              if (!a.trackingNumber && b.trackingNumber) {
                return 1;
              }
              return new Date(b.historyDate).getTime() - new Date(a.historyDate).getTime();
            });
            const matchingHistory = sortedStatus[0];
            if (matchingHistory) {
              step.completed = true;
              const formattedDate = this.formatDate(matchingHistory.historyDate);
              step.date = formattedDate;
              step.trackingNumber = matchingHistory.trackingNumber;
            }
          }
        }
      }

      // Check if orderStatusWebItem directly matches a final step (e.g. Cancelado, Devuelto)
      if (step.finalStep && orderStatusWebItem) {
        if (ApiHomologationService.statusMatchesEquivalents(orderStatusWebItem, equivalents)) {
          step.completed = true;
        }
      }

      return step;
    }).filter((step: OrderStep) => {

      let stepFinal = updatedSteps.find(x => x.finalStep && x.completed && x.trackingNumber && x.trackingNumber != "");
      if (stepFinal == undefined) {
        stepFinal = updatedSteps.find(x => x.finalStep && x.completed);
      }

      if (stepFinal != undefined) {
        const finalStepsAditional = updatedSteps.filter(x => x.finalStep && x.label != stepFinal?.label);
        return !finalStepsAditional.some(x => x.label === step.label);
      } else {
        const stepFinalDefault = updatedSteps.sort(x => x.order).find(x => x.finalStep);
        if (stepFinalDefault) {
          const finalStepsAditional = updatedSteps.filter(x => x.finalStep && x.label != stepFinalDefault.label);
          return !finalStepsAditional.some(x => x.label === step.label);
        } else {
          return false;
        }
      }
    });
    return steps;
  }

  static formatDate(inputDate: string, separator: string = "/"): string {
    try {
      let date: Date;

      // 🔹 Si la fecha tiene formato YYYY-MM-DD o viene con hora, se puede usar new Date()
      if (/^\d{4}-\d{2}-\d{2}/.test(inputDate)) {
        date = new Date(inputDate);
      }
      // 🔹 Si la fecha tiene formato DD/MM/YYYY o MM/DD/YYYY, se parsea manualmente
      else if (/^\d{2}\/\d{2}\/\d{4}$/.test(inputDate)) {
        const parts = inputDate.split("/");
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10);
        const year = parseInt(parts[2], 10);

        // 🔹 Aquí aseguramos que el formato sea DD/MM/YYYY y no MM/DD/YYYY
        if (month > 12) {
          return inputDate; // Si el mes es mayor a 12, ya está en DD/MM/YYYY
        }

        date = new Date(year, month - 1, day);
      }
      else {
        return inputDate; // Si no coincide con ningún formato esperado, devolvemos la entrada
      }

      if (isNaN(date.getTime())) {
        return inputDate;
      }

      // Formatear la fecha en DD/MM/YYYY
      const formattedDay = ("0" + date.getDate()).slice(-2);
      const formattedMonth = ("0" + (date.getMonth() + 1)).slice(-2);
      const formattedYear = date.getFullYear();

      return `${formattedDay}${separator}${formattedMonth}${separator}${formattedYear}`;
    } catch (e) {
      return inputDate;
    }
  }


  static generateUniqueId(): string {
    const timestamp = Date.now().toString(36);
    const random = Math.random().toString(36).substring(2, 15);
    return `${timestamp}-${random}`;
  }

  static normalizeSku = (sku: string): string => {
    return sku.replace(/^0+/, '');
  };


  static associateServicesWithProducts(sortedData: OrderApi[]) {
    let currentProduct: OrderApi | null = null;
    const products: OrderApi[] = [];

    sortedData.forEach(item => {
      if (this.isProduct(item)) {
        // If is product save current
        currentProduct = item;
        currentProduct.services = [];
        products.push(currentProduct);
      } else if (currentProduct && this.isService(item)) {
        currentProduct.services = currentProduct.services ?? [];
        currentProduct.services.push(item);
      }
    });
    return products;
  }

  static isProduct(item: any): boolean {
    return !this.isService(item);
  }

  static isService(item: any): boolean {
    return (
      this.skuExcepted.some(skuPrefix => ApiHomologationService.normalizeSku(item.sku).startsWith(skuPrefix))
    );
  }

  static capitalizeFirstLetter(str?: string) {
    if (str) {
      if (str.length === 0) return str;
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    } else {
      return str;
    }
  }


}
